<template>
	<!--	TP1/TODO: docasne  stary dashboard pro testing-->
	<!--	<dashboard />-->
	<iframe id="wmsIframe" v-if="showIframe" :src="dms3Url" />

</template>

<script>
import Vue from 'vue';

// import Dashboard from '@/modules/dashboard/Dashboard.vue';

import { AUTH_AUTOLOGIN } from '../store/actionTypes';
import { TENANT_NAME } from '../store/authorization/constants';

export default Vue.extend({
	name: 'Home',
	// components: { Dashboard }, TP1/TODO: docasny stary dashbord
	data() {
		return {
			showIframe: false,
		};
	},
	computed: {
		dms3Url() {
			var languageCode = localStorage.getItem("i18nextLng");
			return `${this.dmsSys.DMSC_url}/wms/login/?dms3=&autologon=${this.dms3Hash}&tenant=${this.tenantName}&languageCode=${this.languageCode}`;
		},
		dms3Hash() {
			return this.$store.state.authorization.dms3Hash;
		},
		tenantName() {
			return window.localStorage.getItem(TENANT_NAME) || '';
		},
	},
	beforeCreate() {
		this.$store.dispatch(AUTH_AUTOLOGIN).then(() => {
			this.showIframe = true;
		});
	},
});
</script>
